import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useResetPassword from "../Hooks/useResetPassword";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";

const ForgotPasswordPage = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [email, setEmail] = useState("");
  const { sendResetEmail, loading } = useResetPassword();
  const navigate = useNavigate();

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }
    const response = await sendResetEmail(email);
    // if (response?.success) {
    //   navigate("/");
    // }
  };

  return (
    <div className="flex justify-center flex-col column items-center">
      <div className="d-flex w-full bg-gray-50 p-3">
        <h2 className="text-xl font-bold text-center">ACCOUNT</h2>
      </div>
      <div className="w-full max-w-md p-6 my-16 rounded-lg">
      <p className="text-xl font-semibold mb-5 uppercase">Reset your password</p>
      <p className="text-sm mb-5">Lost your password? Please enter your email address. You will receive a link to create a new password via email.</p>
        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <div className="relative mb-6">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
              required
            />
            <label
              htmlFor="email"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${email ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              Email <span className="text-red-500">*</span>
            </label>
          </div>
          {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
          <button
            type="submit"
            className={`w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Sending Link..." : "Reset Password"}
          </button>
        </form>
          <div className="mt-4 text-left">
            <Link to="/login">
            <p
              className="text-sm underline hover:text-gray-200"
              >
             Cancel
            </p>
              </Link>
          </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
